var map = {
	"./TranslateProvider": 3638,
	"./TranslateProvider.js": 3638,
	"./Translator": 3823,
	"./Translator.js": 3823,
	"./de": 8906,
	"./de.json": 8906,
	"./en": 3026,
	"./en.json": 3026,
	"./fr": 8137,
	"./fr.json": 8137,
	"./it": 740,
	"./it.json": 740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7090;